<template>
    <div class="private-inner">
        <private-header :user="user" />
        <private-menu :user="user" />
        <v-main class="content">
            <router-view :user="user"></router-view>
            <linked-content-popin></linked-content-popin>
            <push-popin></push-popin>
            <snackbar></snackbar>
        </v-main>
        <private-footer />
    </div>
</template>
<script>
import { EventBus } from "src/bus/eventBus";
import LinkedContentPopin from "src/components/linked-content/LinkedContentPopin.vue";
import PushPopin from "src/components/push/PushPopin.vue";
import Snackbar from "src/components/snackbar/Snackbar.vue";
import { Services } from "src/services/Services";
import PrivateHeader from "src/components/header/private/Header.vue";
import PrivateMenu from "src/components/header/private/menu/Menu.vue";
import PrivateFooter from "src/components/footer/Footer.vue";

export default {
    components: {
        LinkedContentPopin,
        PushPopin,
        Snackbar,
        PrivateHeader,
        PrivateMenu,
        PrivateFooter,
    },
    props: ["initialUser"],
    data() {
        return {
            user: { ...this.initialUser, selectedConventionsPopulated: [] },
        };
    },
    async mounted() {
        this.user = await this.populateConventions(this.initialUser);
        EventBus.$on("user:updated", user => (this.user = user));
    },
    methods: {
        async populateConventions(user) {
            const selectedConventionsPopulated = await Services.api.user.getMyConventions();
            return {
                ...user,
                selectedConventionsPopulated,
            };
        },
    },
};
</script>

<style lang="sass" scoped></style>
